// simple queue class 
class Queue {
    _store = [];
    enqueue = (task) => this._store.push(task);
    dequeue = () => this._store.shift();
    length = () => this._store.length;
    peek = () => this._store[0];
}
  
export default Queue; 